import { createAction, handleActions } from 'redux-actions'
import { LOCATION_CHANGE } from 'react-router-redux'
import * as _ from 'lodash'

/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'question'

export const FETCH_QUESTION = createAction(`${BASE_ACTION_NAME}/fetch_question`)
export const FETCH_QUESTION_SUCCESS = createAction(`${BASE_ACTION_NAME}/fetch_question/success`)
export const FETCH_QUESTION_FAILURE = createAction(`${BASE_ACTION_NAME}/fetch_question/failure`)

export const POST_ANSWER = createAction(`${BASE_ACTION_NAME}/post_answer`)
export const POST_ANSWER_SUCCESS = createAction(`${BASE_ACTION_NAME}/post_answer/success`)
export const POST_ANSWER_FAILURE = createAction(`${BASE_ACTION_NAME}/post_answer/failure`)

export const FETCH_QUIZ_RESULT = createAction(`${BASE_ACTION_NAME}/FETCH_QUIZ_RESULT`)
export const FETCH_QUIZ_RESULT_SUCCESS = createAction(`${BASE_ACTION_NAME}/FETCH_QUIZ_RESULT/success`)
export const FETCH_QUIZ_RESULT_FAILURE = createAction(`${BASE_ACTION_NAME}/FETCH_QUIZ_RESULT/failure`)

export const CHANNEL_NAME = 'PresentationChannel'
export const RECEIVE_CHANGE_STATUS = createAction(`${BASE_ACTION_NAME}/receive_change_status`)
export const RECEIVE_CHANGE_PARTICIPANT = createAction(`${BASE_ACTION_NAME}/receive_change_participant`)

/////////////////
//// Reducer ////
/////////////////

const initialState = {
  project: {
    id: 0,
    questions: []
  },
  index: 0,
  type: 0,
  phase: 0,
  participantCount: 0,
  name: null,
  isAnswerSending: false
}

export default handleActions(
  {
    [FETCH_QUESTION_SUCCESS]: (state, action) => ({
      ...state,
      project: action.payload.data
    }),

    [FETCH_QUESTION_FAILURE]: state => ({
      ...state
    }),

    [RECEIVE_CHANGE_STATUS]: (state, action) => ({
      ...state,
      phase: action.payload.phase,
      index: action.payload.index,
      type: action.payload.type,
      name: action.payload.name,
      presentationRank: action.payload.rank,
      answer: action.payload.answer,
      answerCount: action.payload.answerCount
    }),

    [RECEIVE_CHANGE_PARTICIPANT]: state => ({
      ...state,
      participantCount: state.participantCount + 1
    }),

    [POST_ANSWER]: state => ({
      ...state,
      isAnswerSending: true
    }),

    [POST_ANSWER_SUCCESS]: (state, action) => {
      let project = _.cloneDeep(state.project)
      project.questions[state.index].choicedId = action.payload.data.id

      return {
        ...state,
        project: project,
        isAnswerSending: false
      }
    },

    [POST_ANSWER_FAILURE]: state => ({
      ...state,
      isAnswerSending: false
    }),

    [FETCH_QUIZ_RESULT_SUCCESS]: (state, { payload }) => ({
      ...state,
      correctCount: payload.data.correct_count,
      rank: payload.data.rank,
      resultTime: payload.data.time
    }),

    [LOCATION_CHANGE]: state => ({
      ...state,
      isAnswerSending: false
    })
  },
  initialState
)
